exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-proposal-deck-js": () => import("./../../../src/templates/proposal-deck.js" /* webpackChunkName: "component---src-templates-proposal-deck-js" */)
}

